import { useState } from "react";

import { searchCustomer } from "src/apis/customerApi";
import { getItemPopupList } from "src/apis/itemApi";
import { SearchCodeModalForm } from "src/components/common/form/search/SearchCodeModalForm";
import { SearchDateRangeForm } from "src/components/common/form/search/SearchDateRangeForm";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import useUiuxStore from "src/store/useUiuxStore";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";

import {
	defaultTQC3010_R01Filter,
	useTQC3010_R01Store,
} from "./Store_TQC3010_R01";

export const SearchSection_TQC3010_R01 = () => {
	const { TQC3010_R01Filter, setTQC3010_R01Filter } = useTQC3010_R01Store();
	const { setCodeSearchModalProps } = useUiuxStore();
	const { compCdList } = useCommonCodeStore();
	const [pickerVisible, setPickerVisible] = useState(false);
	const [pickerPosition, setPickerPosition] = useState({ top: 0, left: 0 });
	const customerFocusId = "tqc3010_customCd_search";
	const itemFocusId = "tqc3010_itemCd_search";

	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: "customCd",
			category: "거래처",
			focusId: customerFocusId,
			responseMapping: { customCd: "customCd", customNm: "customNm" },
			searchFunction: async (searchText: string) => {
				const response = await searchCustomer(searchText);
				return response.data.data.find((value) => value.customCd === searchText);
			},
			extraFilter: () => ({
				customCd: TQC3010_R01Filter.customCd || "",
				customNm: TQC3010_R01Filter.customNm || "",
			}),
		},
		{
			fieldName: "itemCd",
			category: "품목",
			focusId: itemFocusId,
			responseMapping: { itemCd: "itemCd", itemNm: "itemNm" },
			searchFunction: async (searchText: string) => {
				const response = await getItemPopupList(searchText, "", "", "");
				return response.data.data.find((value) => value.itemCd === searchText);
			},
			extraFilter: () => ({
				itemCd: TQC3010_R01Filter.itemCd || "",
				itemNm: TQC3010_R01Filter.itemNm || "",
			}),
		},
	];

	const { getFieldHandlers } = useInfoFormEvents({
		editData: TQC3010_R01Filter,
		setEditData: setTQC3010_R01Filter,
		defaultData: defaultTQC3010_R01Filter,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: "TQC3010_R01_search",
	});

	return (
		<SearchSectionForm>
			<SearchDropDownForm
				label="사업장"
				value={TQC3010_R01Filter.compCd}
				optionList={compCdList}
				onChangeValue={(compCd) => setTQC3010_R01Filter({ compCd })}
			/>
			<SearchDateRangeForm
				label="출고기간"
				visible={pickerVisible}
				setVisible={setPickerVisible}
				dateRange={TQC3010_R01Filter.dateRange}
				setDateRange={(dateRange) => setTQC3010_R01Filter({ dateRange })}
				pickerPosition={pickerPosition}
				setPickerPosition={setPickerPosition}
			/>
			<SearchCodeModalForm
				label="거래처"
				value={TQC3010_R01Filter.customCd}
				valueLabel={TQC3010_R01Filter.customNm}
				handleFoucsId={customerFocusId}
				onChange={getFieldHandlers("customCd").onChange}
				onDoubleClick={getFieldHandlers("customCd").onDoubleClick}
				onKeyDown={getFieldHandlers("customCd").onEnterKeyDown}
			/>
			<SearchCodeModalForm
				label="품목코드"
				value={TQC3010_R01Filter.itemCd}
				valueLabel={TQC3010_R01Filter.itemNm}
				handleFoucsId={itemFocusId}
				onChange={getFieldHandlers("itemCd").onChange}
				onDoubleClick={getFieldHandlers("itemCd").onDoubleClick}
				onKeyDown={getFieldHandlers("itemCd").onEnterKeyDown}
			/>
		</SearchSectionForm>
	);
};

export default SearchSection_TQC3010_R01;
